<div *ngIf="isShowLoading" class="loading">
  <div class="wrapper">
    <div class="container">
      <img src="../../../../../assets/images/npaperLogo.svg" alt="Logo Npaper" />
      <div class="progressbar mt-2">
      </div>
    </div>
  </div>
</div>